import { hotelLocationType, hotelDestinationType, trainLocationType } from "../Constants";
import { v4 as uuid } from "uuid";

export const tripLocationMapper = (response) => {
  if (!response.model?.length) return [];

  return response.model.map((item) => {
    return {
      ...item,
      value: item.value || item.title || item.slug,
      icon: "icon-pin",
    };
  })
}

const getDescription = (item) => {
  if (item.destinationType === hotelDestinationType.internalHotel.value) {
    return null;
  }

  return item.locationType === hotelLocationType.hotel.value
    ? `${item.countryTitle}, ${item.cityTitle}`
    : item.countryTitle;
};

export const hotelLocationMapper = (response) => {
  if (!response.model?.length) return [];

  return response.model.map((item) => ({
    ...item,
    description: getDescription(item),
    icon: item.locationType === hotelLocationType.city.value ? "icon-pin" : "icon-hotel",
  }));
}

export const nationalityMapper = (response) => {
  if (!response?.length) return [];

  return response.map((item) => {
    return {
      ...item,
      name_fa: item.name_fa || item.name,
      icon: "icon-pin",
    };
  })
}

export const flightLocationMapper = (response) => {
  if (!response.model?.results?.length) return [];

  return response.model.results.flatMap(item => {
    const mainItem = {
      ...item,
      icon: "icon-pin",
      description: item.airports ? "همه فرودگاه ها" : null,
    };

    if (!item.airports) return [mainItem];

    return [
      mainItem,
      ...item.airports.map(airport => ({
        ...airport,
        cityTitle: airport.label,
        icon: "icon-plane",
        cssClass: "mr--2"
      }))
    ];
  });
};

export const trainLocationMapper = (response) => {
  if (!response.model?.length) return [];

  return response.model.map(item => {
    return {
      ...item,
      persianLabel: item.persianLabel || item.label,
      icon: item.type === trainLocationType.city.value ? "icon-pin" : "icon-train",
      description: item.type === trainLocationType.city.value ? "همه ایستگاه‌ها" : null,
    }
  });
};

export const CIPLocationMapper = (response) => {
  if (!response.model?.length) return [];

  return response.model.map(item => {
    return {
      ...item,
      icon: "icon-pin",
    }
  });
};

export const CIPFlightTypeMapper = (response) => {
  if (!response?.length) return [];

  return response
};

// model mapper
export const InsuranceModelMapper = (res) => {
  if (!res?.model?.length) return [];
  return res.model.map((item) => {
    return {
      ...item,
      key: uuid(),
    };
  });
};

export const InsuranceDurationMapper = (res) => {
  if (!res?.length) return [];
  return res.map((item) => {
    return {
      ...item,
      key: uuid(),
    };
  });
};